import React from 'react';

const UnauthorizedPage = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>401 - Unauthorized</h1>
      <p>You are not authorized to access this page.</p>
      <a href="/sign-in">Go Back to Home</a>
    </div>
  );
};

export default UnauthorizedPage;
